import { createTheme } from '@mantine/core';

// Stripe-inspired professional theme
export const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  defaultRadius: 'sm',
  colors: {
    // Professional blue palette
    blue: [
      '#f0f7ff',
      '#e0efff',
      '#b8d9ff',
      '#8fc3ff',
      '#5fadff',
      '#3498ff',
      '#0070f3', // Primary - brand blue
      '#005ed9',
      '#004cb8',
      '#003a96',
    ],
  },
  components: {
    Button: {
      defaultProps: {
        size: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        size: 'sm',
      },
    },
    Select: {
      defaultProps: {
        size: 'sm',
      },
    },
    Card: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
        withBorder: true,
      },
    },
    // Modal/Drawer scroll-lock (react-remove-scroll) preventDefaults EVERY
    // two-finger touchmove (and ctrl+wheel) by default — a phone user who
    // opens any modal while pinch-zoomed is trapped: cannot pan or zoom out
    // (customer-reported on the schedule editor). allowPinchZoom lets
    // multitouch gestures through; one-finger background scroll stays locked.
    Modal: {
      defaultProps: {
        removeScrollProps: { allowPinchZoom: true },
      },
    },
    Drawer: {
      defaultProps: {
        removeScrollProps: { allowPinchZoom: true },
      },
    },
  },
});
